module.exports = __webpack_public_path__ + "static/media/pallette.0f616bfc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeView/logos/pallette.svg
// module id = 334
// module chunks = 0